import { render, staticRenderFns } from "./RelatorioInadimplenciaCard.vue?vue&type=template&id=643f1ba8&"
import script from "./RelatorioInadimplenciaCard.vue?vue&type=script&lang=js&"
export * from "./RelatorioInadimplenciaCard.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioInadimplenciaCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports